module.exports = __webpack_public_path__ + "img/cash.3cc4bd24.png";